import firebase from "firebase";
import moment from "moment";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};
export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== "" && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail) {
    const pattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.minValue) {
    isValid = value.trim() >= rules.minValue && isValid;
  }

  if (rules.maxValue) {
    isValid = value.trim() <= rules.maxValue && isValid;
  }

  return isValid;
};

export const compareDates = (date) => {
  return new Date(date) < new Date();
};
export const createDate = (mm, dd, yyyy) => {
  return mm + "-" + dd + "-" + yyyy;
};

export const logFirebaseEvent = (eventName: string) => {
  firebase.analytics().setCurrentScreen(eventName);
  firebase.analytics().logEvent(eventName, {
    TimeStamp: moment().format("MM-DD-YYYY HH:mm:ss"),
  });
};

export const userLogsFirebaseEvent = () => {
  firebase
    .analytics()
    .setUserProperties({
      Environment: process.env.REACT_APP_BUILD_ENVIRONMENT_FIREBASE,
      TPA: localStorage.getItem("client")?.substr(0,36)
    });
};
